import { api } from "@/services/api";
import { BookingsResponse, GetBookingsProps } from "./get-bookings.types";

export const GetBookingsApi = async ({
  type,
  begin_date,
  end_date,
  limit,
  offset,
}: GetBookingsProps) => {
  const searchParams = new URLSearchParams();
  searchParams.append("type", `${type}`);
  searchParams.append("end_date", end_date);
  searchParams.append("limit", `${limit}`);
  searchParams.append("begin_date", `${begin_date}`);
  searchParams.append("offset", `${offset}`);

  const { data }: BookingsResponse = await api.get(
    `/privaterooms/bookings?${searchParams.toString()}`,
  );

  return data;
};
